<div *ngIf="node.data.layerData && node.data.layerData.renderer && (node.data.layerData.renderer.classBreakInfos || node.data.layerData.renderer.uniqueValueInfos)"
     style="position: relative;">
    <i style="position: absolute; top: 3px; left: 3px; z-index: 3;"
       (click)="toggleBreakDetails(node)"
       [ngClass]="{'icon-ui-down': node.data.showBreakDetail, 'icon-ui-right': !node.data.showBreakDetail}"></i>
    <div *ngIf="node.data.layerData.renderer.classBreakInfos && node.data.layerData.renderer.classBreakInfos.length > 1"
         class="break-infos-group"
         [ngClass]="{'open': node.data.showBreakDetail}">
        <div *ngIf="node.data.layerData.renderer.defaultSymbol"
             class="class-break">
            <div class="color-swatch"
                 [ngStyle]="{'backgroundColor': node.data.layerData.renderer.defaultSymbol.symbol.color}">
            </div>
            {{ node.data.layerData.renderer.defaultSymbol.minValue }} - {{ node.data.layerData.renderer.defaultSymbol.maxValue }}
        </div>
        <div *ngFor="let info of node.data.layerData.renderer.classBreakInfos"
             class="class-break">
            <div class="color-swatch"
                 [ngStyle]="{'backgroundColor': info.symbol.color}">
            </div>
            {{ info.minValue }} - {{ info.maxValue }}
        </div>
    </div>
    <div *ngIf="node.data.layerData.renderer.uniqueValueInfos && node.data.layerData.renderer.uniqueValueInfos.length > 1"
         class="break-infos-group"
         [ngClass]="{'open': node.data.showBreakDetail}">
        <ng-container *ngIf="node.data.layerData.renderer.defaultSymbol">
            <div *ngIf="node.data.layerData.renderer.defaultSymbol.color"
                 #uniqueValueSymbol
                 [attr.data-layer-key]="node.data.layerData | mcLayerKey"
                 [attr.data-r]="node.data.layerData.renderer.defaultSymbol.color.r"
                 [attr.data-g]="node.data.layerData.renderer.defaultSymbol.color.g"
                 [attr.data-b]="node.data.layerData.renderer.defaultSymbol.color.b"
                 class="class-break defaultSymbol">
                {{ node.data.layerData.renderer.defaultLabel }}
            </div>
            <div *ngIf="!node.data.layerData.renderer.defaultSymbol.color"
                 #uniqueValueSymbol
                 [attr.data-layer-key]="node.data.layerData | mcLayerKey"
                 [attr.data-url]="node.data.layerData.renderer.defaultSymbol.url"
                 [attr.data-value]="node.data.layerData.renderer.defaultLabel"
                 class="class-break defaultSymbol">
                {{ node.data.layerData.renderer.defaultLabel }}
            </div>
        </ng-container>
        <ng-container *ngFor="let info of node.data.layerData.renderer.uniqueValueInfos">
            <div *ngIf="info.symbol.color"
                 #uniqueValueSymbol
                 [attr.data-layer-key]="node.data.layerData | mcLayerKey"
                 [attr.data-r]="info.symbol.color.r"
                 [attr.data-g]="info.symbol.color.g"
                 [attr.data-b]="info.symbol.color.b"
                 [attr.data-value]="info.value"
                 class="class-break">
                {{ info.label }}
            </div>
            <div *ngIf="!info.symbol.color"
                 #uniqueValueSymbol
                 [attr.data-layer-key]="node.data.layerData | mcLayerKey"
                 [attr.data-url]="info.url"
                 [attr.data-value]="info.value"
                 class="class-break">
                {{ info.label }}
            </div>
        </ng-container>
    </div>
</div>
<div *ngIf="node.data.layerData && node.data.layerData.mapcoreProps && node.data.layerData.mapcoreProps.routingDetail"
     style="position: relative;">
    <i style="position: absolute; top: 3px; left: 3px; z-index: 3;"
       (click)="toggleBreakDetails(node)"
       [ngClass]="{'icon-ui-down': node.data.showBreakDetail, 'icon-ui-right': !node.data.showBreakDetail}"></i>
    <div class="break-infos-group no-border scrollable"
         [ngClass]="{'open': node.data.showBreakDetail}">
        <div class="routing-group" *ngIf="node.data.layerData.mapcoreProps.routingDetail.distance">
            <span class="routing-item-text">
                Distance:
                    {{ node.data.layerData.mapcoreProps.routingDetail.distance   | number:'1.2-2' }} {{ node.data.layerData.mapcoreProps.routingDetail.unit }}
            </span>
        </div>
        <div class="routing-group" *ngIf="node.data.layerData.mapcoreProps.routingDetail.pointBarriers">
            <div class="routing-item" *ngFor="let barrier of node.data.layerData.mapcoreProps.routingDetail.pointBarriers.features; index as i">
                <img [src]="barrier.symbol.url" class="routing-item-icon">
                <span class="routing-item-text">
                    Barrier {{ i + 1 }}
                    ({{ barrier.geometry.latitude   | number:'1.4-4' }}:{{ barrier.geometry.longitude   | number:'1.4-4' }})
                </span>
            </div>
        </div>
        <div class="routing-group" *ngIf="node.data.layerData.mapcoreProps.routingDetail.stops">
            <div class="routing-item" *ngFor="let stop of node.data.layerData.mapcoreProps.routingDetail.stops.features; index as i">
                <img src="assets/images/maneuvers/esriDMTStopOrigin.png" class="routing-item-icon" />
                <span class="routing-item-text">
                    Location {{ i + 1 }}
                    ({{ stop.geometry.latitude   | number:'1.4-4' }}:{{ stop.geometry.longitude   | number:'1.4-4' }})
                </span>
            </div>
        </div>
        <div class="routing-group" *ngIf="node.data.layerData.mapcoreProps.routingDetail.directions">
            <div class="direction routing-item" *ngFor="let direction of node.data.layerData.mapcoreProps.routingDetail.directions.features">
                <div class="routing-item-instruction">
                    <img class="routing-item-icon" src="assets/images/maneuvers/{{direction.attributes.maneuverType}}.png">
                    <span class="routing-item-text">{{ direction.attributes.text }}</span>
                </div>
                <div class="routing-item-milage" *ngIf="direction.attributes.length > 0">
                    <span class="routing-item-milage-text">{{ direction.attributes.length | number:'1.2-2' }} {{ node.data.layerData.mapcoreProps.routingDetail.unit }} </span>
                    <hr class="routing-item-milage-spacer" />
                </div>
            </div>
        </div>
    </div>
</div>
